import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { segColors, segments } from "../tempConst";
import OTPModal from "../components/Contest/OTPModal";
import WinModal from "../components/Contest/WindModal";
import ScanSignUpForm from "../components/Contest/SignUpForm";
import SpinWheelElements from "../components/Contest/SpinWheelElements";
import {
  addAnalytics,
  getOutletDataByPromo,
  getSpinWheelData,
  getSpunPromoData,
  postQRResendOTP,
  postQRSignUp,
  postQRVerifyOTP,
  postSpinWheelVerifyEmail,
  postSpinWheelVerifyPhone,
} from "../services/spinWheelServices";
import WarningModal from "../components/Contest/WarningModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { appendCart, clearCart } from "../services/cartServices";
import { decryptSpinWheelId, getFormattedDate } from "../helper";
import LoaderModal from "../components/Contest/SpinLoader";
import { toast } from "react-toastify";
import TCModal from "../components/Contest/TCModal";
import ReactGA from "react-ga4";

const ComingSoon = () => {
  const [rotate, setRotate] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [showOTPModal, setOTPModal] = useState(false);
  const [showtc, setShowtc] = useState(false);
  const [loading, setLoader] = useState({ open: false, message: "" });
  const [showWarningModal, setWarningModal] = useState({
    open: false,
    message: "",
  });
  // const [winModal, setWinModal] = useState(false);
  const [isValid, setIsValid] = useState("undefined");
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "+974",
    userId: "",
  });
  const [wheelData, setWheelData] = useState([]);
  const [segmentColors, setWheelColor] = useState([]);
  const [promoData, setPromoData] = useState({});
  const [selected, setSelected] = useState([]);
  const [selectEncrypted, setEncyptedSelected] = useState("");
  const [date, setDate] = useState("");
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let spinId = searchParams.get("spinId");
  const isUAT =
    window.location.hostname.includes("uat") ||
    window.location.hostname.includes("localhost");

  const handleVerify = async () => {
    setLoader({ open: true, message: "Verifying..." });
    try {
      let res = await postSpinWheelVerifyPhone({
        phone: data.phone,
      });
      if (res?.data?.data?.valid) {
        setIsValid("valid");
        setData({
          ...data,
          countryCode: res?.data?.data?.user?.countryCode,
          email: res?.data?.data?.user?.email,
          name: res?.data?.data?.user?.name,
        });
        if (!isUAT) {
          ReactGA.event({
            category: "Custom Events",
            action: "Existing user Spin",
            label: "Existing user Spin",
          });
        }
      } else {
        setIsValid("new");
        if (!isUAT) {
          ReactGA.event({
            category: "Custom Events",
            action: "New user Spin",
            label: "New user Spin",
          });
        }
      }
    } catch (err) {
      err.code === 406
        ? setWarningModal({ open: true, message: err.message })
        : toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoader({ open: false, message: "" });
    }
  };

  useEffect(() => {
    addAnalyticsData("pageView");
  }, []);

  const addAnalyticsData = async (type) => {
    try {
      await addAnalytics({
        date: getFormattedDate(new Date()),
        type: type,
        category: "spinWheel",
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleTryLuck = async () => {
    setLoader({ open: true, message: "Sending OTP..." });
    try {
      let res = await postQRSignUp({
        email: data?.email,
        name: data?.name,
        phone: data?.phone,
        countryCode: data?.countryCode.includes("+")
          ? data?.countryCode
          : "+" + data?.countryCode,
        updateInfo: isValid === "valid" ? false : true,
      });
      setOTPModal(true);
      setData({
        ...data,
        userId: res?.data?.data?.userId,
      });
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoader({ open: false, message: "" });
    }
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleOTPComplete = async (val) => {
    setLoader({ open: true, message: "Loading your luck wheel ..." });
    try {
      let res = await postQRVerifyOTP({
        userId: data?.userId,
        otp: val,
      });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("type", res.data.userType);
      localStorage.removeItem("guestId");
      localStorage.setItem("name", res.data.name);
      setActiveTab(2);
      setOTPModal(false);
      let resSpin = await getSpinWheelData();
      setWheelData(resSpin?.data?.data.list.map((it) => it.name));
      setWheelColor(resSpin?.data?.data.list.map((it) => it.colorCode));
      setEncyptedSelected(resSpin?.data?.data.ss);
      let selectedId = await decryptSpinWheelId(resSpin?.data?.data.ss);
      console.log(resSpin);
      console.log(selectedId);
      setSelected(
        resSpin?.data?.data.list.filter((item) => item._id === selectedId)[0]
      );
    } catch (err) {
      err.code === 406
        ? setWarningModal({ open: true, message: err.message })
        : toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoader({ open: false, message: "" });
    }
  };

  const handleResendOTP = async () => {
    setLoader({ open: true, message: "Re-Sending OTP..." });
    try {
      let res = await postQRResendOTP({ userId: data?.userId });
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoader({ open: false, message: "" });
    }
  };

  const handlePromotionApply = async (discountType) => {
    if (!isUAT) {
      ReactGA.event({
        category: "Custom Events",
        action: "Redeem Now Clicked",
        label: "Redeem Now Clicked",
      });
    }
    await addAnalyticsData("redeemTap");
    if (discountType === "cart") {
      // setWinModal(false);
      setActiveTab(3);
      navigate(
        `/app/booking/${promoData?.outlet?._id}?promo=${promoData?.codeInLowerCase}`
      );
    }
    if (discountType === "product") {
      let payload = {
        items: [
          {
            productId: promoData.products[0],
            qty: 1,
            date: getFormattedDate(date),
          },
        ],
      };
      setLoader({ open: true, message: "Applying Promotion..." });
      try {
        await clearCart();
        await appendCart(payload);
        setActiveTab(1);
        navigate(`/app/cart?spinpromo=${promoData?.codeInLowerCase}`);
      } catch (err) {
        toast.error(err.message, { hideProgressBar: true });
      } finally {
        setLoader({ open: false, message: "" });
      }
    }
  };

  const handleResultSelected = async () => {
    setLoader({ open: true, message: "Loading result..." });
    try {
      let res = await getOutletDataByPromo(selectEncrypted);
      setPromoData(res?.data?.data);
      // setWinModal(true);
      setActiveTab(3);
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    } finally {
      setLoader({ open: false, message: "" });
    }
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  useEffect(() => {
    if (spinId) {
      fetchSpinData();
    }
  }, []);

  const fetchSpinData = async () => {
    try {
      let res = await getSpunPromoData(spinId);
      localStorage.setItem("token", res?.data?.data?.user?.token);
      localStorage.setItem("name", res?.data?.data?.user?.name);
      localStorage.setItem("type", res?.data?.data?.user?.userType);
      setSelected(res?.data?.data?.promo);
      setPromoData({
        ...res?.data?.data?.promo,
        outlet: res?.data?.data?.outlet,
      });
      // setWinModal(true)
      setActiveTab(3);
    } catch (err) {
      toast.error(err.message, { hideProgressBar: true });
    }
  };

  return (
    <PageWrapper>
      {loading.open && <LoaderModal message={loading.message} />}
      {showtc && <TCModal onClose={() => setShowtc(false)} />}
      {showOTPModal && (
        <OTPModal
          phone={data.countryCode + data.phone}
          email={data.email}
          onClose={() => setOTPModal(false)}
          onOTPComplete={handleOTPComplete}
          onResend={handleResendOTP}
        />
      )}
      {showWarningModal.open && (
        <WarningModal
          message={showWarningModal?.message}
          onClose={() => {
            setWarningModal({ open: false, message: "" });
            navigate("/auth/home");
          }}
        />
      )}
      {activeTab === 3 && (
        <WinModal
          onClose={() => setActiveTab(2)}
          onApply={handlePromotionApply}
          selected={selected}
          promoData={promoData}
          onDateDataChange={handleDateChange}
          date={date}
        />
      )}
      {activeTab === 1 && (
        <ScanSignUpForm
          onTryLuck={handleTryLuck}
          isValid={isValid}
          onVerify={handleVerify}
          formData={data}
          onChange={handleChange}
          onTCClick={() => setShowtc(true)}
        />
      )}
      {activeTab === 2 && (
        <SpinWheelElements
          onResultSelected={() => {
            setTimeout(handleResultSelected, 2000);
          }}
          onRotate={() => setRotate(true)}
          rotate={rotate}
          selected={selected}
          segments={wheelData}
          segmentColors={segmentColors}
        />
      )}
    </PageWrapper>
  );
};

export default ComingSoon;

const PageWrapper = styled.div`
  height: 100vh;
  overflow: auto;
  background: #230533;
`;
